import { render } from "./ListaDocumentosComponent.vue?vue&type=template&id=41687e85&scoped=true"
import script from "./ListaDocumentosComponent.vue?vue&type=script&lang=js"
export * from "./ListaDocumentosComponent.vue?vue&type=script&lang=js"

import "./ListaDocumentosComponent.vue?vue&type=style&index=0&id=41687e85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41687e85"]])

export default __exports__